import React from 'react';

export const TableRowSelect = ({ title, options, name, value, onChange }) => (
    <tr>
        <th>{title}</th>
        <td>
            <select name={name} className="form-control" value={value} onChange={onChange}>
                {options}
            </select>
        </td>
    </tr>
);


// WEBPACK FOOTER //
// ./Public/src/js/component/parametro/children/tr-select.jsx